import http from "../http-common";

const getAll = () => {
    return http.get("/donations");
};

const get = (id) => {
    return http.get(`/donations/${id}`);
};


const create = data => {
    return http.post("/donations", data);
};

const update = (id, data) => {
    return http.put(`/donations/${id}`, data);
};

const remove = id => {
    return http.delete(`/donations/${id}`);
};

const removeAll = () => {
    return http.delete(`/donations`);
};

const findByYear = year => {
    return http.get(`/donations?year=${year}`);
};

const DonationService = {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findByYear
};

export default DonationService;
